import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gitkraken': {
    width: 592,
    height: 512,
    paths: [
      {
        d: 'M565.7 118.1c11.8 31.6 18.3 65.7 18.3 101.4 0 155.1-122.6 281.6-276.3 287.7v-145.8c-8.4 0.5-16.6 0.4-23.4 0v145.9c-153.7-6.2-276.3-132.7-276.3-287.8 0-35.7 6.5-69.8 18.3-101.3 2.3-6.2 9.3-9.2 15.3-6.6 5.7 2.4 8.5 8.8 6.3 14.6-10.9 29-16.9 60.5-16.9 93.3 0 134.6 100.4 245.7 230.2 262.7v-123.7c-7.9-1.6-15.4-3.7-23-6.2v104c-106.7-26-185.9-122.1-185.9-236.8 0-91.8 50.8-171.8 125.8-213.3 5.8-3.2 13-0.9 15.9 5 2.7 5.5 0.7 12.1-4.7 15.1-67.9 37.7-113.9 110.1-113.9 193.2 0 93.4 57.9 173.2 139.8 205.4v-92.2c-14.2-4.5-24.8-17.7-24.8-33.5 0-13.1 6.7-24.4 17.3-30.5-8.2-79.6-44.5-58.6-44.5-83.9v-14.8c0-38 87.9-161.7 129.1-164.7 2.6-0.2 5.1-0.2 7.6 0 41.1 2.9 129 126.7 129 164.7v14.7c0 25.3-36.2 4.4-44.5 83.9 10.5 6.1 17.3 17.4 17.3 30.5 0 15.8-10.7 29-24.9 33.5v92.2c81.9-32.3 139.8-112.1 139.8-205.4 0-83.2-46-155.6-113.9-193.2-5.3-2.9-7.4-9.6-4.7-15.1 2.9-5.9 10.2-8.2 15.9-5 75 41.5 125.8 121.5 125.8 213.3 0 114.7-79.2 210.9-185.9 236.8v-104c-7.5 2.6-15.1 4.7-23 6.2v123.7c129.9-17 230.2-128.1 230.2-262.7 0-32.8-6-64.3-16.9-93.3-2.2-5.7 0.6-12.2 6.3-14.6 6-2.6 13 0.5 15.3 6.6zM365.9 275.5c-13.1 0-23.7 10.6-23.7 23.7 0 13.2 10.7 23.7 23.7 23.7 13.1 0 23.7-10.6 23.7-23.7 0-13.2-10.7-23.7-23.7-23.7zM226.1 322.8c13.2 0 23.7-10.7 23.7-23.7 0-13.1-10.6-23.7-23.7-23.7-13.2 0-23.7 10.7-23.7 23.7s10.5 23.7 23.7 23.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/gitkraken.js
// module id = 854
// module chunks = 0